import React, { useEffect, useState } from 'react';
import {joinClasses} from "../../../../../../Utils/className.util";

// @ts-ignore
import styles from './CharactersCount.module.scss';

interface Props {
	value?: string;
	limit: number;
}

const CharactersCount: React.FC<Props> = ({ value, limit }) => {
	const [count, setCount] = useState(value ? value.length : 0);

	useEffect(() => {
		setCount(value ? value.length : 0);
	}, [value]);

	const isOverLimit = count >= limit;

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				isOverLimit ? styles.overLimit : '',
			])}>
			{count} / {limit}
		</div>
	);
};

export default CharactersCount;
